/* eslint-disable react/require-default-props, no-unused-vars */
import React from 'react'
import { oneOf, string, bool, number } from 'prop-types'
import { motion } from 'framer-motion'
import Video from './Video'
import Title from './Title'

import { styles } from './styles'

const VideoContainer = ({
  className,
  size = 'small',
  children,
  animated = false,
  delay = 0.5,
}) => {
  const base = (
    <div css={styles.sizes[size]} className={className}>
      <div>{children}</div>
    </div>
  )

  if (animated) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay }}
      >
        {base}
      </motion.div>
    )
  }
  return base
}

VideoContainer.propTypes = {
  className: string,
  size: oneOf(['small', 'big']),
  animated: bool,
  delay: number,
}

VideoContainer.Title = Title
VideoContainer.Video = Video

export default VideoContainer
